import { render } from "./filter_veggie.svg?vue&type=template&id=09446708?inline"
const script = {}
script.render = render

export default script